/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S9_BodyInputs */

const tr_servis_s9_body = /** @type {(inputs: Servis_S9_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryeri (Trendyol, Shopify, Hepsiburada, n11), ödeme sağlayıcı (Sipay), kargo (Geliver) ve e-Fatura (QNB) gibi üçüncü taraf hizmetleri, ilgili sağlayıcıların kendi şart ve koşullarına tabidir. Şirket, bu hizmetlerin kesintisinden veya yapılan değişikliklerden sorumlu değildir.`)
};

const en_servis_s9_body = /** @type {(inputs: Servis_S9_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third party services such as marketplaces (Trendyol, Shopify, Hepsiburada, n11), the payment provider (Sipay), shipping (Geliver) and e-Fatura (QNB) are subject to the terms and conditions of the respective providers. The Company is not responsible for interruptions of these services or for changes made to them.`)
};

const de_servis_s9_body = /** @type {(inputs: Servis_S9_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienste Dritter wie Marktplätze (Trendyol, Shopify, Hepsiburada, n11), Zahlungsanbieter (Sipay), Versand (Geliver) und e-Fatura (QNB) unterliegen den eigenen Bedingungen der jeweiligen Anbieter. Das Unternehmen haftet nicht für Unterbrechungen dieser Dienste oder für an ihnen vorgenommene Änderungen.`)
};

const ru_servis_s9_body = /** @type {(inputs: Servis_S9_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Услуги третьих лиц, такие как маркетплейсы (Trendyol, Shopify, Hepsiburada, n11), платежный провайдер (Sipay), доставка (Geliver) и e-Fatura (QNB), регулируются собственными условиями соответствующих поставщиков. Компания не несет ответственности за перебои в этих услугах или за внесенные в них изменения.`)
};

/**
* | output |
* | --- |
* | "Third party services such as marketplaces (Trendyol, Shopify, Hepsiburada, n11), the payment provider (Sipay), shipping (Geliver) and e-Fatura (QNB) are subj..." |
*
* @param {Servis_S9_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s9_body = /** @type {((inputs?: Servis_S9_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S9_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s9_body(inputs)
	if (locale === "de") return de_servis_s9_body(inputs)
	if (locale === "ru") return ru_servis_s9_body(inputs)
	return tr_servis_s9_body(inputs)
});